<span class="content" (click)="contentClick()" (keyup.enter)="contentClick()">
  <ng-content></ng-content>
</span>

<button mat-icon-button class="close-button" aria-label="Dismiss notification" (click)="dismiss()">
  <mat-icon svgIcon="close"></mat-icon>
</button>
